// eslint-disable-next-line import/prefer-default-export
export const dashboardMenu = [{
  id: 'LiveDashboard',
  name: 'Live',
  permission: 'view_live_dashboard',
}, {
  id: 'revenue',
  name: 'Revenue',
  permission: 'view_revenue_dashboard',
  client_config: 'dashboard.show_revenue_dashboard',
}, {
  id: 'insights',
  name: 'Insights',
  permission: 'view_insights_dashboard',
  client_config: 'dashboard.show_insights_dashboard',
}, {
  id: 'performance',
  name: 'Performance',
  permission: 'view_performance_dashboard',
  client_config: 'dashboard.show_performance_dashboard',
}, {
  id: 'operations',
  name: 'Operations',
  permission: 'view_operations_dashboard',
  client_config: 'dashboard.show_operations_dashboard',
}, {
  id: 'value_discovery',
  name: 'Value Discovery',
  permission: 'view_value_discovery_dashboard',
  client_config: 'dashboard.show_value_discovery_dashboard',
}, {
  id: 'value_discovery_1',
  name: 'Value Discovery 1',
  permission: 'view_value_discovery_1_dashboard',
  client_config: 'dashboard.show_value_discovery_1_dashboard',
}, {
  id: 'value_discovery_2',
  name: 'Value Discovery 2',
  permission: 'view_value_discovery_2_dashboard',
  client_config: 'dashboard.show_value_discovery_2_dashboard',
}, {
  id: 'value_discovery_3',
  name: 'Freight Analytics',
  permission: 'view_value_discovery_3_dashboard',
  client_config: 'dashboard.show_value_discovery_3_dashboard',
}, {
  id: 'value_discovery_4',
  name: 'Procurement Analytics',
  permission: 'view_value_discovery_4_dashboard',
  client_config: 'dashboard.show_value_discovery_4_dashboard',
}, {
  id: 'cost_kg_month_wise',
  name: 'Cost/KG - Month wise',
  permission: 'view_cost_kg_month_wise_dashboard',
  client_config: 'dashboard.show_cost_kg_month_wise_dashboard',
}, {
  id: 'cost_kg_source_wise',
  name: 'Cost/KG - Source wise',
  permission: 'view_cost_kg_source_wise_dashboard',
  client_config: 'dashboard.show_cost_kg_source_wise_dashboard',
}, {
  id: 'transporter_performance',
  name: 'Transporter Performance',
  permission: 'view_transporter_performance_dashboard',
  client_config: 'dashboard.show_transporter_performance_dashboard',
}, {
  id: 'depot_performance',
  name: 'Depot Performance',
  permission: 'view_depot_performance_dashboard',
  client_config: 'dashboard.show_depot_performance_dashboard',
}, {
  id: 'business_dashboard',
  name: 'Business Dashboard',
  permission: 'view_business_dashboard',
  client_config: 'dashboard.show_business_dashboard',
}, {
  id: 'packing_performance',
  name: 'Packing Performance',
  permission: 'view_packing_performance_dashboard',
  client_config: 'dashboard.show_packing_performance_dashboard',
}, {
  id: 'depot_level_cost_flow_dashboard',
  name: 'Depot Level cost flow',
  permission: 'view_depot_level_cost_flow_dashboard',
  client_config: 'dashboard.show_depot_level_cost_flow_dashboard',
}, {
  id: 'transit_dashboard',
  name: 'Transit Dashboard',
  permission: 'view_transit_dashboard',
  client_config: 'dashboard.show_transit_dashboard',

}, {
  id: 'indent_performance',
  name: 'Indent Performance',
  permission: 'view_indent_movement_dashboard',
  client_config: 'dashboard.show_indent_movement_dashboard',
},
{
  id: 'total_freight_cost_dashboard',
  name: 'Total Freight Cost',
  permission: 'view_total_freight_cost_dashboard',
  client_config: 'dashboard.show_total_freight_cost_dashboard',
},
{
  id: 'variance_dashboard',
  name: 'Variance Analysis',
  permission: 'view_variance_dashboard',
  client_config: 'dashboard.show_variance_dashboard',
},
{
  id: 'overview_dashboard',
  name: 'Overview',
  permission: 'view_overview_dashboard',
  client_config: 'dashboard.show_overview_dashboard',
},
{
  id: 'signify_operations_dashboard',
  name: 'Signify Operations',
  permission: 'view_signify_operations_dashboard',
  client_config: 'dashboard.show_signify_operations_dashboard',
},
{
  id: 'signify_depot_dashboard',
  name: 'Signify Depot Performance',
  permission: 'view_signify_depot_dashboard',
  client_config: 'dashboard.show_signify_depot_dashboard',
},
{
  id: 'perfetti_operation_dashboard',
  name: 'Perfetti Operations',
  permission: 'view_perfetti_operation_dashboard',
  client_config: 'dashboard.show_perfetti_operation_dashboard',
},
{
  id: 'destination_dashboard',
  name: 'Destination Performance',
  permission: 'view_destination_dashboard',
  client_config: 'dashboard.show_destination_dashboard',
},
{
  id: 'source_level_dashboard',
  name: 'Source Level Performance',
  permission: 'view_source_level_dashboard',
  client_config: 'dashboard.show_source_level_dashboard',
},
{
  id: 'service_level_performance_dashboard',
  name: 'Service Level Performance Dashboard',
  permission: 'service_level_performance_dashboard',
  client_config: 'dashboard.show_service_level_performance_dashboard',
},
{
  id: 'fap_invoice_dashboard',
  name: 'FAP Invoice Metrics',
  permission: 'view_fap_invoice_dashboard',
  client_config: 'dashboard.show_fap_invoice_dashboard',
},
{
  id: 'operations_overview_dashboard',
  name: 'Operations Overview Dashboard',
  permission: 'view_operations_overview_dashboard',
  client_config: 'dashboard.show_operations_overview_dashboard',
},
{
  id: 'shipment_tracking_metrics_dashboard',
  name: 'Shipment and Tracking Metrics',
  permission: 'view_shipment_tracking_metrics_dashboard',
  client_config: 'dashboard.show_shipment_tracking_metrics_dashboard',
},
{
  id: 'indents_material_summary_dashboard',
  name: 'Indents Materials Summary',
  permission: 'view_indents_material_summary_dashboard',
  client_config: 'dashboard.show_indents_material_summary_dashboard',
},
{
  id: 'freight_spend_financials_dashboard',
  name: 'Freight Spend Financials Dashboard',
  permission: 'view_freight_spend_financials_dashboard',
  client_config: 'dashboard.show_freight_spend_financials_dashboard',
},
{
  id: 'customer_fulfillment_dashboard',
  name: 'Customer Fulfillment Dashboard',
  permission: 'view_customer_fulfillment_dashboard',
  client_config: 'dashboard.show_customer_fulfillment_dashboard',
},
{
  id: 'network_characterstics_dashboard',
  name: 'Network Characterstics',
  permission: 'view_network_characterstics_dashboard',
  client_config: 'dashboard.show_network_characterstics_dashboard',
},
{
  id: 'transporter_carrier_performance_dashboard',
  name: 'Transporter Carrier Performance',
  permission: 'view_transporter_carrier_performance_dashboard',
  client_config: 'dashboard.show_transporter_carrier_performance_dashboard',
},
{
  id: 'value_discovery_5',
  name: 'Scenario Planning',
  permission: 'view_value_discovery_5_dashboard',
  client_config: 'dashboard.show_value_discovery_5_dashboard',
},
{
  id: 'emissions_dashboard',
  name: 'Emissions Dashboard',
  permission: 'view_emissions_dashboard',
  client_config: 'dashboard.show_emissions_dashboard',
},
{
  id: 'discover_more_dashboard',
  name: 'Discover more',
  permission: 'view_discover_more_dashboard',
  client_config: 'dashboard.show_discover_more_dashboard',
}, {
  id: 'value_discovery_6',
  name: 'Value Discovery 6',
  permission: 'view_value_discovery_6_dashboard',
  client_config: 'dashboard.show_value_discovery_6_dashboard',
},
{
  id: 'quicksight_console',
  name: 'Quicksight console',
  permission: 'view_quicksight_console',
  client_config: 'dashboard.show_quicksight_console',
}];
